import {
  IElementsVisibilityState,
  EElementsVisibilitySummaryView,
} from '../../../../../shared/ServicePickerWidget/types/reducers/elementsVisibility';

import { EPresetType } from './types';

export const ELEMENTS_VISIBILITY_PRESET: { [key in EPresetType]: IElementsVisibilityState } = {
  [EPresetType.AddForm]: {
    publicationWrapper: {
      isVisibleWithoutPackages: true,
    },
    promotionWrapper: {
      isMoneySourceWidgetVisible: false,
    },
    summary: {
      view: EElementsVisibilitySummaryView.TwoColumns,
      isMoneySourceWidgetVisible: true,
    },
  },
  [EPresetType.NewAddForm]: {
    publicationWrapper: {
      isVisibleWithoutPackages: true,
    },
    promotionWrapper: {
      isMoneySourceWidgetVisible: false,
    },
    summary: {
      view: EElementsVisibilitySummaryView.TwoColumns,
      isMoneySourceWidgetVisible: true,
    },
    experiments: {
      allowDisablePromotionSection: true,
    },
  },
  [EPresetType.NewAddFormEarlyPublish]: {
    publicationWrapper: {
      isVisibleWithoutPackages: true,
    },
    promotionWrapper: {
      isMoneySourceWidgetVisible: false,
    },
    summary: {
      view: EElementsVisibilitySummaryView.TwoColumns,
      isMoneySourceWidgetVisible: true,
    },
    experiments: {
      allowDisablePromotionSection: true,
      hidePromotionToggle: true,
    },
  },
  [EPresetType.MyOffers]: {
    publicationWrapper: {
      isVisibleWithoutPackages: false,
    },
    promotionWrapper: {
      isMoneySourceWidgetVisible: true,
    },
    summary: {
      view: EElementsVisibilitySummaryView.Multiline,
      isMoneySourceWidgetVisible: false,
    },
  },
};
